export default "../ui-icons_cc0000_256x240.png";